import './App.css';
import user from "./SocialProfile/data/user.json";
import data from "./Statistics/data/data.json";
import friends from "./FriendsList/data/friends.json";
import items from "./TransactionHistory/data/transactions.json";
import { Profile } from './SocialProfile/Profile.jsx';
import { Statistics } from './Statistics/Statistics.jsx';
import { FriendList } from './FriendsList/Friends.jsx';
import { TransactionHistory } from './TransactionHistory/TransactionHistory.jsx';
console.log(items)

function App() {
  return (
    <div className="App">
      <Profile avatar={user.avatar} username={user.username} tag={user.tag} location={user.location} stats={user.stats} />
      <Statistics title="Upload statisctics" data={data} />
      <FriendList friends={friends} />
      <TransactionHistory items={items} />
    </div>
  );
}

export default App;
